/* eslint react/jsx-pascal-case:0 no-mixed-operators:0 */

import { useEffect, useState, useContext } from 'react';
import { 
  Box, 
  Stack, 
  Button,
  ButtonGroup,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
} from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import { 
  MaterialReactTable, 
  useMaterialReactTable, 
} from 'material-react-table';

import { Layout as DashboardLayout } from 'layouts/portal/layout';
import { Departments, availableCategoryGroups, AuthContext, BudgetEdit } from 'components';

const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});


export const Budgets = () => {
  const [ visibleItems, setVisibleItems ] = useState([]);
  const [ reportData, setReportData ] = useState({});
  const [ columns, setColumns ] = useState([]);
  const [ columnOrder, setColumnOrder ] = useState([]);
  const [ selectedCategoryGroups, setSelectedCategoryGroups ] = useState([]);
  const [ selectedDepartment, setSelectedDepartment ] = useState(availableCategoryGroups[0]);
  const [ budgetTotals, setBudgetTotals ] = useState({})
  const { items, collections, selectedSeason, customCategories, exchangeRates, selectedCollection, accountBudgets } = useContext(AuthContext);

  console.log('budget_totals', budgetTotals)
  /*
  Columns:
    Dynamic - Iterate all season collections
    Static - Collection Category totals, Season Totals
  Rows:
    Dynamic - Iterate all department categories
    Static - Collection Total
   */

  const calculate_totals = () => {
    let budget_totals = {}
    Object.keys(customCategories).forEach((category) => {
      Object.keys(collections).forEach((collection) => {
        console.log('asd', selectedDepartment, customCategories[category].category_group)
        if (collection !== 'all' && selectedDepartment === customCategories[category].category_group) {
          let column_data = reportData[customCategories[category].category_id]?.collections?.[collection]
          let budget = 0
          try {
            budget = accountBudgets[collection][customCategories[category].category_group_id][customCategories[category].category_id]?.budget || 0
          } catch (e) {}
          let spend = column_data?.spend || 0

          // Add totals for collections (Bottom row)
          if (budget_totals.hasOwnProperty(collection)) {
            budget_totals[collection].budget += budget
            budget_totals[collection].spend += spend
          } else {
            budget_totals[collection] = {
              budget,
              spend
            }
          }

          // Add totals for categories (Right row)
          if (budget_totals.hasOwnProperty(category)) {
            budget_totals[category].budget += budget
            budget_totals[category].spend += spend
          } else {
            budget_totals[category] = {
              budget,
              spend
            }
          }

          // Add all totals (Bottom right row)
          if (budget_totals.hasOwnProperty('total')) {
            budget_totals['total'].budget += budget
            budget_totals['total'].spend += spend
          } else {
            budget_totals['total'] = {
              budget,
              spend
            }
          }
        }
      })
    })
    setBudgetTotals(budget_totals)
  }

  useEffect(calculate_totals, [collections, selectedSeason, customCategories, selectedCollection, selectedDepartment, accountBudgets])
  
  useEffect(() => {
    if (selectedCategoryGroups.indexOf(selectedDepartment) === -1) {
      setSelectedDepartment(selectedCategoryGroups[0])
    }
  }, [selectedCategoryGroups])

  useEffect(() => {
    if (!customCategories) return
    setSelectedCategoryGroups([...new Set(Object.keys(customCategories).map((e) => customCategories[e].category_group))])
  }, [customCategories])

  useEffect(() => {
    //                  | collection A | collection B | ...
    // category 
    //    budget        | Comes from accountCategorySectionBudgets
    //    spent         | Calculate on commited items
    //    balance
    if (!items || !items[selectedSeason]) return

    const spendings = {}
    Object.keys(items[selectedSeason]).forEach((item_id) => {
      let collection = items[selectedSeason][item_id].collectionId || '-'
      let category = items[selectedSeason][item_id].categoryId || '-'

      if (!spendings.hasOwnProperty(category)) {
        spendings[category] = {
          displayName: customCategories[category] ? customCategories[category].category : '-',
          department: customCategories[category] ? customCategories[category].category_group : '-',
          spend: 0, // Total spend of all items
          collections: {}
        }
      }

      if (!spendings[category]['collections'].hasOwnProperty(collection)) {
        spendings[category]['collections'][collection] = {
          displayName: collections[collection] ? collections[collection].displayName : '-',
          spend: 0, // Dynamically calculated
          budget: 0 // Set below from account budgets
        }
      }

      if (items[selectedSeason][item_id].priceInfo?.price && items[selectedSeason][item_id].orderStatus === 1) {
        let quantity = items[selectedSeason][item_id].priceInfo?.quantity || 1
        let currency = items[selectedSeason][item_id].priceInfo?.currency
        let price = parseFloat(items[selectedSeason][item_id].priceInfo?.price)

        if (currency !== 'USD' && exchangeRates.hasOwnProperty(currency)) {
          // Change rate to USD
          price /= exchangeRates[currency].rate
        }
        spendings[category].spend += price * quantity
        spendings[category]['collections'][collection].spend += price * quantity
      }
    })
    setReportData(spendings)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, selectedSeason, selectedCollection])

  useEffect(() => {
    let report_rows = []
    Object.keys(customCategories).forEach((category) => {
      const sorting = customCategories && customCategories[category]?.sorting || []
      if (category !== 'sections')
      report_rows.push({
        ...customCategories[category],
        priority: sorting.indexOf(category)
      })
    })

    const new_visible_items = report_rows
      .filter((row) => row.category_group === selectedDepartment)
      .sort((a, b) => a.priority > b.priority ? 1 : -1)
      new_visible_items.push({
        category_id: 'total',
        category: 'Total'
      })
    setVisibleItems(new_visible_items)
  }, [accountBudgets, selectedDepartment, selectedSeason, selectedCollection, customCategories, budgetTotals])

  useEffect(() => {
    if (!Object.keys(reportData).length) return

    let default_columns = [
      { 
        id: 'category',
        accessorKey: 'category',
        header: 'Category',
        enableHiding: false,
        size: 50,
      },
      { 
        id: 'budget_titles',
        accessorKey: 'budget_titles',
        header: '',
        enableHiding: false,
        size: 50,
        Cell: ({ row, cell }) => 
          <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={{padding: 0}}>Budget</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{padding: 0}}>Spent</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{padding: 0}}>Balance</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ,
      }
    ]

    let dynamic_columns = []
    
    Object.keys(collections).forEach((collection) => {
      if (collection !== 'all') {
        dynamic_columns.push({
          id: collections[collection].displayName,
          accessorKey: collections[collection].displayName,
          accessorFn: (e) => {
            if (e.category_id === 'sections') {
              return null
            }

            if (e.category_id === 'total') {
              let budget = budgetTotals[collection]?.budget || 0
              let spend = budgetTotals[collection]?.spend || 0
              return {
                budget: formatter.format(budget),
                spend: formatter.format(spend),
                balance: formatter.format((budget - spend)),
              }
            }

            let column_data = reportData[e.category_id]?.collections?.[collection]
            let budget = 0
            try {
              budget = accountBudgets[collection][e.category_group_id][e.category_id]?.budget || 0
            } catch (e) {}
            let spend = column_data?.spend || 0

            return {
              budget: formatter.format(budget),
              spend: formatter.format(spend),
              balance: formatter.format((budget - spend)),
            }
          },
          header: collections[collection].displayName,
          displayOrder: collections[collection].displayOrder,
          Cell: ({ row, cell }) => <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={{padding: 0, width: 100, textAlign: 'right'}}>
                  {row.original.category_id === 'total' ? (cell.getValue()?.budget) :
                  (<BudgetEdit category={row.original} collection={collection} budget={cell.getValue()?.budget} />)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{padding: 0, width: 100, textAlign: 'right'}}>{cell.getValue()?.spend || 0}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{padding: 0, width: 100, textAlign: 'right'}}>{cell.getValue()?.balance || 0}</TableCell>
              </TableRow>
            </TableBody>
          </Table>,
        })
      }
    })
    
    setColumns([
      ...default_columns, 
      ...dynamic_columns.sort((a, b) => a.displayOrder > b.displayOrder ? 1 : -1),
      ...[
        {
          id: 'category_totals',
          header: 'Total',
          accessorFn: (e) => {
            const budget = budgetTotals[e.category_id]?.budget || 0
            const spend = budgetTotals[e.category_id]?.spend || 0
            return {
              budget: formatter.format(budget),
              spend: formatter.format(spend),
              balance: formatter.format((budget - spend)),
            } 
          },
          Cell: ({ row, cell }) => <Table>
            <TableBody>
              <TableRow>
              <TableCell sx={{padding: 0, width: 100, textAlign: 'right'}}>{cell.getValue()?.budget || 0}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{padding: 0, width: 100, textAlign: 'right'}}>{cell.getValue()?.spend || 0}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{padding: 0, width: 100, textAlign: 'right'}}>{cell.getValue()?.balance || 0}</TableCell>
              </TableRow>
            </TableBody>
          </Table>,
        }
      ]
    ])
  // eslint-disable-next-line
  }, [accountBudgets, reportData, collections, selectedSeason, selectedCollection, budgetTotals])

  useEffect(() => {
    setColumnOrder(columns.map((column) => column.id));
  }, [columns]);

  const table = useMaterialReactTable({
    columns: columns,
    data: visibleItems,
    density: 'comfortable',
    enableColumnActions: false,
    enableColumnOrdering: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableSorting: false,
    enableStickyHeader: true,
    onColumnOrderChange: setColumnOrder,
    defaultColumn: {
      minSize: 100, //allow columns to get smaller than default
      maxSize: 400, //allow columns to get larger than default
      size: 180, //make columns wider by default
    },
    layoutMode: 'grid-no-grow',
    enableColumnResizing: false,
    state: {
      columnOrder,
      columnPinning: { left: ['category', 'budget_titles'], right: ['category_totals'] }
    },
    muiTableHeadCellProps: {
      align: 'right',
      sx: {
        width: 'calc(var(--col-category-size) * 1.2px)',
      }
    },
    muiTableBodyCellProps: {
      align: 'right',
      sx: {
        width: 'calc(var(--col-category-size) * 1.2px)',
      }
    },
  })
    
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DashboardLayout>
        <Typography variant="h2">----- Budgets OLD</Typography>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 4,
          }}
        >
          <Departments onChange={setSelectedDepartment} />
          <Stack style={{position: 'relative'}} spacing={3} sx={{marginBottom: 10, marginTop: 1}}>
            <MaterialReactTable table={table} />
          </Stack>
        </Box>
      </DashboardLayout>
    </LocalizationProvider>
  );
};
